export default {
  ADMINISTRATOR: 1,
  ANALYSTHL: 2,
  MANAGER: 3,
  MANAGERHL: 4,
  CLIENT: 5,
  ADMINHL: 6,
  SUMMARIZER: 8,
};
